import React, {
	memo,
	useCallback,
	useMemo
} from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Tab } from 'semantic-ui-react';

import { log } from '../../../../../services/utils';

import { useAuthState } from '../../../../../contexts/AuthContext';
import { useAdminState } from '../../../../../contexts/AdminContext';

import Actions from '../../../../Shared/Actions';
import HelpModal from '../../../../Shared/HelpModal';
import TableRowActions from '../../../../Table/Cells/TableRowActions';
import multiWordFilterFn from '../../../../Table/filterFunctions/multiWordFilterFn';
import PageHeader from '../../../../Shared/PageHeader';
import Table from '../../../../Table';

const AgenciesTab = ( { activeIndex } ) => {
	const history = useHistory();

	const { user: { permissions } } = useAuthState();
	const { user } = useAdminState();

	const onView = useCallback( ( { id } ) => {
		history.push( {
			pathname: `/operations/agencies/directory/${ id }`,
			state: {
				text: '\u2190\u00A0\u00A0Back to User',
				to: {
					pathname: `/administration/users/${ user?.id }`,
					state: { activeIndex }
				}
			}
		} );
	}, [
		activeIndex,
		history,
		user
	] );

	const tableRowActionsCell = useCallback( ( { row } ) => {
		const actions = [
			{
				action: onView,
				componentProps: { color: 'pink' },
				disable: !permissions.viewAgencies.canExecute,
				icon: 'search',
				permission: permissions.viewAgencies.isAvailable,
				text: 'View Agency'
			}
		];

		return (
			<TableRowActions
				actions={ actions }
				row={ row.original }
			/>
		);
	}, [ onView, permissions ] );

	const columns = useMemo( () => [
		{
			accessor: 'name',
			Header: 'Agency Name',
			filter: multiWordFilterFn,
			minWidth: 60
		}
	], [] );

	const actionColumn = useMemo( () => ( {
		id: 'id_actions',
		Cell: tableRowActionsCell,
		disableFilters: true,
		disableResizing: true,
		width: 100,
		minWidth: 100,
		maxWidth: 100
	} ), [ tableRowActionsCell ] );

	const renderColumns = useMemo(
		() => permissions.viewAgencies.isAvailable
			? [
				...columns,
				actionColumn
			]
			: columns,
		[
			actionColumn,
			columns,
			permissions
		]
	);

	return (
		<Tab.Pane as="div">
			{ log( 'AgenciesTab' ) }
			<Actions />
			<PageHeader
				title={
					<>
						<span>Agencies</span>
						<HelpModal
							id={ 35 }
							triggerStyles={ { verticalAlign: 'top' } }
						/>
					</>
				}
			/>
			<div className="table-container">
				<Table
					columns={ renderColumns }
					data={ user.agencies }
					showCount={ user.agencies.length > 10 }
					showEmptyRows={ false }
					showPagination={ user.agencies.length > 10 }
				/>
			</div>
		</Tab.Pane>
	);
};

AgenciesTab.propTypes = { activeIndex: PropTypes.number };

export default memo( AgenciesTab );
